/* ltt-card.js — size-chip behavior on ltt-product-card.
   A chip swap updates the visible price and the ATC form's variant id.
   Delegated once at document level: cards are rendered by many sections and
   re-rendered by the theme editor, so per-card binding would leak. */
(function () {
  'use strict';
  if (window.lttCardBound) return;
  window.lttCardBound = true;

  /* Take the figure out of a money string the same way the card's Liquid does:
     the last space-separated word ("LE 1,700" -> "1,700"). The currency word
     never changes between variants, so only the figure is swapped. */
  function moneyFigure(money) {
    var words = money.trim().split(/\s+/);
    return words[words.length - 1];
  }

  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input.matches('.ltt-card-product__chip input')) return;

    var card = input.closest('.ltt-card-product');
    if (!card) return;

    var priceBox = card.querySelector('[data-card-price]');
    if (priceBox) {
      var num = priceBox.querySelector('[data-price-num]');
      if (num) num.textContent = moneyFigure(input.dataset.price || '');

      // A compare-at belongs to the variant, not to the product: a size that
      // isn't discounted must not inherit the struck-through price of one that is.
      var compare = priceBox.querySelector('[data-price-compare]');
      if (compare) {
        var was = input.dataset.compare;
        compare.hidden = !was;
        // Write into the value span, not the <s> itself: the <s> also holds the
        // visually-hidden "Regular price" label, which textContent would erase.
        var wasValue = compare.querySelector('[data-price-compare-value]');
        if (was && wasValue) wasValue.textContent = was;
      }
    }

    var idInput = card.querySelector('[data-card-variant-id]');
    if (idInput) {
      idInput.value = input.value;
      idInput.disabled = input.dataset.available !== 'true';
    }

    var button = card.querySelector('.ltt-card-product__atc[name="add"]');
    if (button) button.disabled = input.dataset.available !== 'true';
  });
})();
